// extracted by mini-css-extract-plugin
module.exports = {"root":"Accordion_root__3BOB2","text":"Accordion_text__vGQzq","uppercase":"Accordion_uppercase__FY0bb","icon":"Accordion_icon__cNiYt"};